import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import { getExamDetail } from "@/api/exam";
import { AppModule } from "@/store/modules/app";
let ExamPublish = class ExamPublish extends Vue {
    constructor() {
        super(...arguments);
        this.pub_status = 0;
        this.hasUser = false;
        this.paperId = '';
        this.banBtn = false;
        this.examInfo = {};
        this.btnLock = false;
    }
    get isSidebarExpanded() {
        return AppModule.sidebar.opened;
    }
    created() {
        this.loadExamInfo();
    }
    async loadExamInfo() {
        if (!this.examId)
            return;
        this.$emit("loading", true);
        try {
            const res = await getExamDetail(this.examId);
            const data = res.data.data;
            // this.examInfo = data
            const publishTime = data.publishTime;
            const publishStatus = data.examStatus;
            if (publishStatus === 1 && publishTime) {
                this.banBtn = true;
            }
            else {
                this.banBtn = false;
            }
            this.pub_status = publishStatus || 0;
            this.hasUser = data.participateCount > 0;
            this.paperId = data.paperId;
        }
        catch (_) { }
        finally {
            this.$emit('loading', false);
        }
    }
    last() {
        this.$emit("go-page-two");
    }
    createdExamination() {
        this.btnLock = true;
        this.$emit("publish", this.pub_status);
        this.btnLock = false;
    }
    changePubStatus(status) {
        this.pub_status = status;
    }
};
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], ExamPublish.prototype, "examId", void 0);
ExamPublish = tslib_1.__decorate([
    Component({
        name: 'ExamPublish',
    })
], ExamPublish);
export default ExamPublish;
